import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useEvents } from "@/hooks/useEvents";
import { LeagueGroups } from "@/components/LeagueGroups";

export default function Results() {
  const [sport, setSport] = useState("");
  const { data: sports } = useQuery({ queryKey: ["sports"], queryFn: () => api.get("/sports").then((r) => r.data) });
  const { data } = useEvents({ state: "post", limit: 150, ...(sport ? { sport } : {}) }, 120000);
  return (
    <div className="space-y-5">
      <h1 className="font-display text-4xl font-black uppercase tracking-tight sm:text-5xl">Results</h1>
      <div className="scroll-thin flex gap-2 overflow-x-auto">
        {[{ key: "", name: "All" }, ...(sports || [])].map((s) => (
          <button
            key={s.key}
            data-testid={`results-filter-${s.key || "all"}`}
            onClick={() => setSport(s.key)}
            className={`shrink-0 rounded-full px-4 py-1.5 text-sm transition-colors ${
              sport === s.key ? "bg-[#10B981] font-bold text-[#0B0E14]" : "bg-[#121824] text-slate-300 hover:bg-[#1A2234]"
            }`}
          >
            {s.name}
          </button>
        ))}
      </div>
      <LeagueGroups events={data} showOdds={false} empty="No recent results." />
    </div>
  );
}
